import React from "react";
import "../../assets/css/slider.css"; // Custom styling

const CourtyardHighlights = () => {
    return (
        <div className="slider-container">
            {/* <video
                className="home_video"
                src={"https://youtu.be/8oTjmLWuXcM?si=ilBRgkrhuRqBCXC6"}
                type="video/mp4"
                poster={""}
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
            /> */}
            <iframe
                src="https://www.youtube.com/embed/8oTjmLWuXcM?si=xfet3RUnS58U7OfJ"
                title="heighlight"
                // allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                allowfullscreen
                style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    width: "100%",
                    height: "100%",
                    border: "none"
                }}
            >
            </iframe>

        </div>
    )
}

export default CourtyardHighlights;